module.exports = __webpack_public_path__ + "img/icon_edda.1a059f7d.png";